import { render, staticRenderFns } from "./BadgeMetalPendant.vue?vue&type=template&id=6b40bf42&scoped=true&"
import script from "./BadgeMetalPendant.vue?vue&type=script&lang=js&"
export * from "./BadgeMetalPendant.vue?vue&type=script&lang=js&"
import style0 from "./BadgeMetalPendant.vue?vue&type=style&index=0&id=6b40bf42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40bf42",
  null
  
)

component.options.__file = "BadgeMetalPendant.vue"
export default component.exports